<template>
    <div class="task">
        <p-header :title="noteTitle || '購買內容 & 備註'"/>
        <div class="input-data" v-if="hasNote">
            <div class="item note" :class="{'err': noteErr}">
                <span>{{ noteTitle || '購買內容 & 備註' }}</span>
                <a-textarea v-model="note" :placeholder="notePlaceholder || '份量/ 規格/ 詳細內容'" :focus="focus"></a-textarea>
                <div v-show="noteErr">
                    <div class="line"></div>
                    <span class="err-msg">
                        {{ noteErr }}
                    </span>
                </div>
                <limit-size/>
            </div>
        </div>
        <task-input v-model="expectedPrice" v-if="hasPrice" :err="priceErr"/>
        <div class="advanced" @click="showAdvanced" v-if="hasAdvanced">
            <div class="title">
                進階需求?
            </div>
            <div class="buttons">
                <div class="button" :class="{'active': isSelfBuy}">
                    <img v-show="!isSelfBuy" src="@/assets/img/ordered.svg">
                    <img v-show="isSelfBuy" src="@/assets/img/ordered-green.svg">
                    已訂購
                </div>
                <div class="button" :class="{'active': isInsulation}">
                    <img v-show="!isInsulation" src="@/assets/img/insulation.svg">
                    <img v-show="isInsulation" src="@/assets/img/insulation-green.svg">
                    需保溫
                </div>
                <div class="button" :class="{'active': vat.length}">
                    <img v-show="!vat.length" src="@/assets/img/vat.svg">
                    <img v-show="vat.length" src="@/assets/img/vat-green.svg">
                    統編
                </div>
            </div>
        </div>

        <photo-uploader v-model="photos" v-if="hasPhoto"/>
        <div class="detail">
            <div class="button green" @click="update">
                儲存內容
            </div>
        </div>
        <shop-advanced-modal ref="showAdvanced" @onConfirm="setAdvanced"/>
    </div>
</template>

<script>
    import Header from "../Header";
    import ATextare from "../AutoHeighTextarea";
    import LimitSize from "../LimitSize";
    import PhotoUploader from "./PhotoUploader";
    import ShopAdvancedModal from "../modal/ShopAdvancedModal";
    import TaskExpectedInput from "./TaskExpectedInput";
    export default {
        name: "TaskNote",
        components: {
            'photo-uploader': PhotoUploader,
            'shop-advanced-modal': ShopAdvancedModal,
            'p-header': Header,
            'a-textarea': ATextare,
            'limit-size': LimitSize,
            'task-input': TaskExpectedInput,
        },
        props: {
            noteTitle: {
                type: String,
            },
            notePlaceholder: {
                type: String,
            },
            noteData: {
                require: true,
                default() {
                    return [];
                }
            },
            noteRequire: {
                type: Boolean,
                default: true,
            },
            priceRequire: {
                type: Boolean,
                default: true,
            },
            focus: {
                default() {
                    return true;
                }
            },
        },
        data() {
            return {
                note: '',
                isSelfBuy: false,
                selfBuyName: '',
                selfBuyPhone: '',
                isInsulation: false,
                vat: '',
                photos: [],
                expectedPrice: '',
                hasNote: false,
                hasAdvanced: false,
                hasPhoto: false,
                hasPrice: false,
                noteErr: '',
                priceErr: '',
            }
        },
        created() {
            if ('note' in this.noteData) {
                this.hasNote = true;
                this.note = this.noteData['note'];
            }

            if ('isSelfBuy' in this.noteData) {
                this.hasAdvanced = true;
                this.isSelfBuy = this.noteData['isSelfBuy'];
            }

            if ('isInsulation' in this.noteData) {
                this.hasAdvanced = true;
                this.isInsulation = this.noteData['isInsulation'];
            }

            if ('vat' in this.noteData) {
                this.hasAdvanced = true;
                this.vat = this.noteData['vat'];
            }

            if ('photos' in this.noteData) {
                this.hasPhoto = true;
                this.photos = this.noteData['photos'];
            }

            if ('expectedPrice' in this.noteData) {
                this.hasPrice = true;
                this.expectedPrice = this.noteData['expectedPrice'];
            }
        },
        methods: {
            showAdvanced() {
                this.$refs.showAdvanced.show(this.isSelfBuy, this.isInsulation, this.vat, this.selfBuyName, this.selfBuyPhone);
            },
            setAdvanced(advance) {
                this.isSelfBuy = advance['ordered'];
                this.selfBuyName = advance['orderedName'];
                this.selfBuyPhone = advance['orderedPhone'];
                this.isInsulation = advance['insulation'];
                this.vat = advance['vat'];
            },
            canUpdate() {
                let n = true;
                this.noteErr = '';
                if (this.noteRequire) {
                    if (this.note === undefined) return false;
                    if (this.note === null) return false;
                    n = this.note.length > 0;
                }
                if (!n) this.noteErr = '請填寫購買內容'

                let e = true;
                this.priceErr = '';
                if (this.priceRequire && this.hasPrice) {
                    if (this.expectedPrice === undefined) return false;
                    if (this.expectedPrice === null) return false;
                    e =  /^(([1-9]([0-9]+)?)|0)$/.test(this.expectedPrice.trim());
                }
                if (!e) this.priceErr = '請填寫代付金額'

                return n && e;
            },
            update() {
                if (!this.canUpdate()) return;

                let arr = [];

                if ('note' in this.noteData) {
                    arr['note'] = this.note;
                }

                if ('isSelfBuy' in this.noteData) {
                    arr['isSelfBuy'] = this.isSelfBuy;
                    arr['selfBuyName'] = this.selfBuyName;
                    arr['selfBuyPhone'] = this.selfBuyPhone;
                }

                if ('isInsulation' in this.noteData) {
                    arr['isInsulation'] = this.isInsulation;
                }

                if ('vat' in this.noteData) {
                    arr['vat'] = this.vat;
                }

                if ('photos' in this.noteData) {
                    arr['photos'] = this.photos;
                }

                if ('expectedPrice' in this.noteData) {
                    arr['expectedPrice'] = this.expectedPrice;
                }

                this.$emit('update', arr);
            },
        }
    }
</script>

<style lang="scss">
    .task {
        .item {
            textarea {
                min-height: 100px !important;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .task {
        height: 100%;
    }

    .search {
        margin: 10px 15px;
    }

    .advanced {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 15px;
        padding: 10px 15px;
        border-radius: 5px;
        background-color: #FFFFFF;
        box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
        cursor: pointer;
        user-select: none;

        .title {
            color: #4a4a4a;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
        }

        .buttons {
            display: flex;
            align-items: center;

            .button {
                display: flex;
                align-items: center;
                color: #9b9b9b;

                img {
                    margin-left: 10px;
                    margin-right: 2px;
                }

                &.active {
                    color: #339933;
                }
            }
        }
    }

    .input-data {
        margin: 15px;

        .item {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 4px;
            background-color: rgba(255,255,255,1);
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.5);
            margin-top: 5px;
            padding: 10px;

            span {
                margin-bottom: 10px;
                color: rgba(0,0,0,1);
                font-size: 14px;
                line-height: 20px;
            }

            input {
                width: 100%;
                font-size: 14px;
                line-height: 20px;
                border: none;
            }
        }
    }

    .detail {
        padding: 15px 25px;
        padding-bottom: 90px;

        .title {
            color: rgba(0, 0, 0, 1);
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            text-align: left;
        }

        .item {
            display: flex;
            justify-content: space-between;
            color: rgba(74, 74, 74, 1);
            font-size: 14px;
            line-height: 20px;
            text-align: left;
            padding: 13px 0;
            border-bottom: solid 1px rgba(221,221,221,1);

            &:nth-child(4) {
                border-bottom: none;
            }

            .span {
                width: 145px;
            }

            .input {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: calc(100% - 145px);
                text-align: right;
                font-size: 14px;
                line-height: 20px;

                &.placeholder {
                    color: rgba(155, 155, 155, 1);
                }

                input {
                    text-align: right;
                    width: 100%;
                    border: none;
                    font-size: 14px;

                    &::placeholder {
                        color: rgba(155, 155, 155, 1);
                    }
                }
            }
        }

        .button {
            cursor: pointer;
            user-select: none;
            height: 45px;
            border-radius: 35px;
            background-color: #808080;
            color: rgba(255,255,255,1);
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 15px 0;
            position: absolute;
            width: calc(100% - 50px);
            bottom: 0;

            &.green {
                background-color: #339933;
            }
        }
    }

    .note {
        position: relative;

        .err-msg {
            position: absolute;
            color: rgba(244,67,54,1) !important;
            font-size: 12px;
            font-weight: 500;
            line-height: 17px;
            bottom: -8px !important;
            margin: 0 !important;
        }

        .line {
            border: solid 2px white;
            position: absolute;
            width: 103px;
            bottom: -2px;
            left: 6px;
        }

        &.err {
            border: 2px solid rgba(255,153,153,1);
            box-shadow: 0 2px 8px 0 rgba(255,153,153,0.35);
        }
    }
</style>
